import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo-wrapper">
          <div className="logo-icon">
            <svg className="w-16 h-16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L3 7V17L12 22L21 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="url(#gradient1)"/>
              <defs>
                <linearGradient id="gradient1" x1="3" y1="2" x2="21" y2="22">
                  <stop offset="0%" stopColor="#14b8a6"/>
                  <stop offset="100%" stopColor="#06b6d4"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h1 className="loading-title">MyVenueMate</h1>
        </div>
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="loading-text">Loading...</p>
      </div>
      
      {/* Powered by footer */}
      <div className="loading-footer">
        <p className="text-xs text-gray-500">
          Powered by <span className="font-semibold text-teal-600">MYONK</span>
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
